import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MenuItem } from './top-menu.service';
import { TranslationService } from '../../core';

@Injectable()
export class LeftMenuService {
	constructor(private _translationService: TranslationService) { }

	getMenu(code: string): Observable<MenuItem[]> {
		return new Observable(observer => {
			observer.next([
				{
					name: this._translationService.getString('Správa'),
					// CHECK THIS
					url: ''
				}
			]);
			observer.complete();
		});
	}
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/services/left-menu.service.ts